import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  EditTwoTone,
  ExclamationCircleOutlined,
  EyeTwoTone,
  InfoCircleTwoTone,
} from '@ant-design/icons';
import { Alert, Button, List, Typography } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import useRouter from '../../hooks/useRouter';
import { AppActionType, AppContextType } from '../../types/appContext.type';

//Image Import
import Annotation_Intro_Image from '../../assets/images/annotationgif.gif';

//Css Import
import './styles/annotationIntro.less';

const { Text } = Typography;

const annotationInfo = [
  {
    icon: <InfoCircleTwoTone twoToneColor="#fa8c16" />,
    title: 'Vastu Review In Progress...',
    description:
      'We’re currently working on applying Vastu guidelines to your floor plan. Annotations will be available shortly.',
  },
  {
    icon: <CheckCircleTwoTone twoToneColor="#fa8c16" />,
    title: 'Add New Area',
    description: 'Click and draw a box to highlight a new area on the image.',
  },
  {
    icon: <EditTwoTone twoToneColor="#fa8c16" />,
    title: 'Edit Area',
    description: 'Click on any existing box to move or resize it as needed.',
  },
  {
    icon: <CloseCircleTwoTone twoToneColor="#fa8c16" />,
    title: 'Delete Area',
    description: 'Instantly remove any unwanted area with just one click.',
  },
  {
    icon: <EyeTwoTone twoToneColor="#fa8c16" />,
    title: 'View Detected Areas',
    description:
      'See all areas already detected and make adjustments if necessary.',
  },
];

export default function AnnotationFeatureScreen() {
  const { dispatch } = useContext(AppContext) as AppContextType;
  const { navigate } = useRouter();

  const handleSubmit = () => {
    dispatch({ type: AppActionType.removeFloorPlanSequence });
    navigate(ROUTES.MAIN);
  };

  return (
    <>
      <div className="annotation-feature-screen">
        <div className="annotation-feature-screen-content">
          <div className="annotation-feature-screen-title title-lg medium">
            <div> Annotation Screen (Mark Areas on Image) </div>
            <div className="body-base text-primary">Desktop version Only</div>
          </div>
          <div className="annotation-feature-div">
            <div className="annotation-feature-content-image">
              <img src={Annotation_Intro_Image}></img>
            </div>
            <div className="annotation-feature-content">
              <div style={{ maxWidth: 720, margin: 'auto' }}>
                <Text>
                  You can now mark and manage specific areas directly on your
                  Vastu images with our new
                  <Text strong> Annotation Screen</Text>. Here's what you can
                  do:
                </Text>

                <List
                  itemLayout="horizontal"
                  dataSource={annotationInfo}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <span style={{ fontSize: 20 }}>{item.icon}</span>
                        }
                        title={<Text strong>{item.title}</Text>}
                        description={<Text>{item.description}</Text>}
                      />
                    </List.Item>
                  )}
                />

                <Alert
                  showIcon
                  type="warning"
                  icon={<ExclamationCircleOutlined />}
                  message="Note: This feature is currently available only on the web version of Vastu.AI"
                />
              </div>
            </div>
          </div>
          <div className="screen-submit-btn">
            <Button
              onClick={handleSubmit}
              type="primary"
              className="submit-btn"
            >
              Got It
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
